export const MOLD_TYPES = [
    'Single mold',
    'Common mold',
    'Family mold',
    'Multiple mold',
    'Double injection',
    'Insert injection'
];